import { lazy } from "react";

const Home = lazy(() => import("../components/pages/Home"));
const Jobs = lazy(() => import("../components/pages/Jobs"));
const FlowRouts = lazy(() => import("./FlowRouts"));
const LoginPage = lazy(() => import("../components/pages/Login/Login"));
const SignUpPage = lazy(() => import("../components/pages/SignUp/SignUpPage"));
const ForgotPasswordPage = lazy(() => import("../components/pages/ForgotPassword/ForgotPasswordPage"));
const UserManagementListing = lazy(() => import("../components/UserManagement/UserManagementListing"));
const SubscriptionManagementListing = lazy(() => import("../components/SubscriptionManagement/SubscriptionManagementListing"));
const HospitalManagementListing = lazy(() => import("../components/HospitalManagement/HospitalManagementListing"));
const ViewHospitalDetails = lazy(() => import("../components/HospitalManagement/ViewHospitalDetails"));
const CandidateManagementListing = lazy(() => import("../components/CandidateManagement/CandidateManagementListing"));
const ViewCandidateDetails = lazy(() => import("../components/CandidateManagement/ViewCandidateDetails/ViewCandidateDetails"));

export const publicRoutes = [
  { path: "/", Component: LoginPage },
  { path: "/login", Component: LoginPage },
  { path: "/signup", Component: SignUpPage },
  { path: "/forgot-password", Component: ForgotPasswordPage },
];

export const protectedRoutes = [
  { path: "/home", Component: Home },
  { path: "/user-management", Component: UserManagementListing },
  { path: "/subscription-management", Component: SubscriptionManagementListing },
  { path: "/hospital-management/:type", Component: HospitalManagementListing },
  { path: "/hospital-management/:type/view/:id", Component: ViewHospitalDetails },
  { path: "/candidate-management/:type", Component: CandidateManagementListing },
  { path: "/candidate-management/:type/view/:candidateId", Component: ViewCandidateDetails },
  { path: "/jobs", Component: Jobs },
  { path: "/employeeFlow/*", Component: FlowRouts },
];
